import { PSTFieldNames } from "@common/data-models/fields/pst-field-names";
import { ObjectTypes } from "@common/enums/object-types";
import { ResultGroup, ResultGroupingDefinition, FixedEntriesResultGroup } from "@common/data-models/search-results/result-group";
import { SearchResults } from "@common/data-models/search-results/search-results";
import { DataStore } from '@common/data-models/data-store/data-store';
import { Record } from "@common/data-models/records/record";
import { WireRecord } from "@discover/data-models/records/wire-record";
import { IDiscoverService } from "@discover/interfaces/i-discover-service";
import { SingleViewStateRecord } from "@common/data-models/records/single-viewstate-record";
import { map, takeUntil } from "rxjs/operators";

export class DiscoverSearchResults extends SearchResults {

    public static discoverService: IDiscoverService = null;
    // public static latestModTime: DateTime = null;
    public static viewState: SingleViewStateRecord = null;

    public wires: Array<WireRecord> = [];
    public addWire(wire: WireRecord) {
        // if (!wire.title || !wire.text || !wire.beginText || wire.title.trim() == "" || wire.text.length < 100 || wire.beginText.trim().startsWith("(Copyright")) {
        //     return;
        // }
        //wire.title = wire.beginText.trim().substring(0, 150);
        this.wires.push(wire);
        this.byGuid[wire.wireId] = wire;
    }

    public getAllResults(): Array<Record> {
        let ret: Array<Record> = [];
        for (let wire of this.wires) {
            ret.push(wire);
        }
        return ret;

    }

    public wireGroups: { [id: string]: ResultGroup<WireRecord> } = {};

    public static wireGroupDefs: { [id: string]: ResultGroupingDefinition } = {};

    private get wireGroupFields(): Array<string> {
        return DiscoverSearchResults.discoverService.groupByWireKeys;
    }

    public remove(rec: Record) {
        super.remove(rec);

        if (rec.type == ObjectTypes.WIRE) {
            for (let i = 0; i < this.wires.length; i++) {
                if (this.wires[i].guid == rec.guid) {
                    this.wires.splice(i, 1);
                    break;
                }
            }
            for (let field in DiscoverSearchResults.wireGroupDefs) {
                if (this.wireGroups['Creator']) this.wireGroups['Creator'].remove(DiscoverSearchResults.wireGroupDefs['Creator'].valueConvertor(rec), <WireRecord>rec);
            }
        }
    }

    // public sortGroups(sortBy: any, sortOrder: string, groupSortOrder: string) {
    //     if (this.objectType == ObjectTypes.WIRE) {
    //         let groups = this.getGroups();

    //         for (let field of groups) {
    //             this.wireGroups['Creator'].sort(DiscoverSearchResults.wireGroupDefs['Creator'].groupKeyComparator(groupSortOrder), DiscoverSearchResults.wireGroupDefs[sortBy].recordComparator(sortOrder));
    //         }
    //     }
    // }

    public dispose() {
        super.dispose();
        this.objectType = null;
        this.wires = [];
        this.users = [];
        this.wireGroups = {};
    }

    public getGroups(): Array<string> {
        for (let wire of this.wires) {
            if (!this.wireGroups[wire.wireType]) {
                this.wireGroups[wire.wireType] = new ResultGroup<WireRecord>();
            }
        }
        let groupType = Object.keys(this.wireGroups)
        return Object.keys(this.wireGroups)
    }


    public getGroupCount(key: string): number {
        return this.wireGroups[key]?.keys?.length || 0;
    }

    public rebuildGroups(groupBy: string, sortBy: any, sortOrder: string, groupSortOrder: string) {

        const viewStateGroupingField = DiscoverSearchResults.viewState.viewStateGrouping.Value;
        for (let field of this.getGroups()) {
            // Clear all groups
            if (this.objectType == ObjectTypes.WIRE)
                if (field == PSTFieldNames.PSTWireCategory || field == PSTFieldNames.Creator) {
                    let filterDef = DiscoverSearchResults.viewState.viewStateFilter.map[field];
                    if (filterDef && !filterDef.IsAllSelected) {
                        this.wireGroups[field] = new FixedEntriesResultGroup<WireRecord>(<Array<string>>filterDef.Value);
                    } else {
                        this.wireGroups[field] = new ResultGroup<WireRecord>();
                        this.wireGroups[field].clear();
                    }
                } else {
                    if (!this.wireGroups[field]) this.wireGroups[field] = new ResultGroup<WireRecord>();
                    this.wireGroups[field].clear();
                }
            if (!this.wireGroups[SearchResults.groupByField]) {
                SearchResults.groupByField = groupBy;
            }
        }
        for (let wire of this.wires) {
            this.wireGroups[wire.wireType].addToGroups(DiscoverSearchResults.wireGroupDefs[wire.wireType].valueConvertor(wire), wire);
        }
        for (let key in this.wireGroups) {
            this.buildTree(key);
        }
    }

    public mergeSearchResults(results: DiscoverSearchResults) {
        // for (let group in results.wireGroups) {
        //     if (!this.wireGroups[group]) this.wireGroups[group] = new ResultGroup<WireRecord>();

        //     for (let key of results.wireGroups[group].keys) {
        //         let found: boolean = false;
        //         for (let k of this.wireGroups[group].keys) {
        //             if (k.value == key.value) {
        //                 found = true;
        //                 break;
        //             }
        //         }
        //         if (!found) {
        //             this.wireGroups[group].keys.push(key);
        //             this.wireGroups[group].entries[key.value] = [];
        //         }
        //     }

        //     for (let key in results.wireGroups[group].entries) {
        //         for (let wire of results.wireGroups[group].entries[key]) {
        //             if (!this.byGuid[wire.guid]) {
        //                 this.wires.push(wire);
        //                 this.byGuid[wire.guid] = wire;
        //                 this.wireGroups[group].entries[key].unshift(wire);
        //                 if (this.wireGroups[group].entries[key].length > 20) {
        //                     // A.T. if it is less than 20 (or whatever value we agree on), it will saturate the column, such that we don't have big gaps
        //                     this.wireGroups[group].entries[key].pop(); // remove last element if size > 20, otherwise it will keep growing
        //                 }
        //             }
        //         }
        //     }
        // }
    }

    override buildTree(groupBy: string): void {

        this.treeDataSource.disconnect();
        this.treeDataSource.connect(this).pipe(
            takeUntil(this.onDispose),
            map(data => {
                this.cardItemHeights = data.map(item => {
                    // console.log(item)
                    switch (this.objectType) {
                        default: {
                            switch (item.level) {
                                case 0: return 40;
                                // case 1: return 30; //TODO: HANDLE ASSIGNMENT VIEW
                                default: return 117;
                            }
                        }
                    }
                })
            })
        ).subscribe();

        this.treeLikeData = this.wireGroups[groupBy].keys.map(key => {
            return {
                id: key.value,
                label: key.display,
                children: this.wireGroups[groupBy].entries[key.value].map(entry => {
                    return {
                        id: entry.data.wireId,
                        children: [],
                        object: entry
                    };
                })
            };
        });
        this.treeDataSource.data = this.treeLikeData;
        this.treeControl.expandAll();
    }
}
DataStore.registerSearchResults("discover", new DiscoverSearchResults());
